<template>
  <Layout>
    <div>
      <PageHeader
        :title="pageTitle"
        :items="breadCrumb"
      />
      <b-card>
        <b-row>
          <b-col>
            <base-table
              :fields="fields"
              :items="projects"
              :busy="loadingProjects"
            >
              <template v-slot:cell(name)="row">
                <span :data-id="row.item.project.id">{{ row.item.project.name }}</span><br>
                <p style="font-size:11px; line-height: 11px">{{ row.item.project.description }}</p>
                <!-- <pre>{{ row.item.project.choose_ambits_locked }}</pre> -->
              </template>
              <template v-slot:cell(choose_ambits_locked)="row">
                <b-form-checkbox
                  v-model="row.item.project.choose_ambits_locked"
                  switch
                  @change="changeChooseAmbitsStatus(row.item.project)"
                >
                </b-form-checkbox>
              </template>
              <template v-slot:cell(ambits_locked)="row">
                <b-form-checkbox
                  v-model="row.item.project.ambits_locked"
                  switch
                  @change="changeAmbitsStatus(row.item.project)"
                >
                </b-form-checkbox>
              </template>
              <template v-slot:cell(strategic_vars_locked)="row">
                <b-form-checkbox
                  v-model="row.item.project.strategic_vars_locked"
                  switch
                  @change="changeVariableStatus(row.item.project)"
                >
                </b-form-checkbox>
              </template>
              <template v-slot:cell(poll_locked)="row">
                <b-form-checkbox
                  v-model="row.item.project.poll_locked"
                  switch
                  @change="changePollStatus(row.item.project)"
                >
                </b-form-checkbox>
              </template>
              <template v-slot:cell(scenario_locked)="row">
                <b-form-checkbox
                  v-model="row.item.project.scenario_locked"
                  switch
                  @change="changeSceneStatus(row.item.project)"
                >
                </b-form-checkbox>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" variant="link" @click="row.toggleDetails">
                  <i :class="`fe-settings fe-4x ${ row.detailsShowing ? 'text-primary' : 'text-muted' }`"></i>
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <b-card class="m-0 p-0">
                  <h5>{{ row.item.project.name }}</h5>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/experts/`" >
                    <b-img :src="require('@assets/images/icons/gestionar-expertos.png')" class="p-1" fluid /><br>Gestionar Expertos
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/areas/`" >
                    <b-img :src="require('@assets/images/icons/ambito.png')" class="p-1" fluid /><br>Ámbitos
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/changes/`" >
                    <b-img :src="require('@assets/images/icons/ambito.png')" class="p-1" fluid /><br>Cambios
                  </b-button>
                  <!-- 
                  <b-button v-show="false" variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/actors/`">
                    <i class="fas fa-user-secret fe-5x text-danger"></i><br>Actores
                  </b-button>
                  <b-button v-show="false" variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/objectives/`">
                    <i class="fab fa-empire fe-5x text-success"></i><br>Objetivos
                  </b-button>
                  -->
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/changeFactors/`" >
                    <b-img :src="require('@assets/images/icons/variables-estrategicas.png')" class="p-1" fluid /><br>Variables Estratégicas
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/scenaryVariables/`" >
                    <b-img :src="require('@assets/images/icons/variables-hipotesis.png')" class="p-1" fluid /><br>Variables e Hipótesis
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" @click="openTestModal(row.item.project)" >
                    <b-img :src="require('@assets/images/icons/encuesta.png')" class="p-1" fluid /><br>Encuesta
                  </b-button>
                  <b-button variant="link" class="width-120" size="sm" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/excludedWords/`">
                     <b-img :src="require('@assets/images/icons/palabras-excluidas.png')" class="p-1" fluid /><br>Palabras Excluidas
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/wordsCloud/`" >
                    <b-img :src="require('@assets/images/icons/nube-palabras.png')" class="p-1" fluid /><br>Nube de Palabras
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/project/${row.item.project.id}/wordsCorrelation/`" >
                    <b-img :src="require('@assets/images/icons/correlacion-palabras.png')" class="p-1" fluid /><br>Correlación de Palabras
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/report/project/matrix/${row.item.project.id}/`" >
                    <b-img :src="require('@assets/images/icons/plano-matriz-mic-mac.png')" class="p-1" fluid /><br>Plano de matriz MIC MAC
                  </b-button>
                  <b-button variant="link" class="width-120" :disabled="actionsBusy" :to="`/report/project/morph-analysis/${row.item.project.id}/`" >
                    <b-img :src="require('@assets/images/icons/analisis-morfologico.png')" class="p-1" fluid /><br>Análisis Morfológico
                  </b-button>
                </b-card>
              </template>
            </base-table>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-modal
      v-model="testModal"
      hide-footer
      :title="'Encuesta'"
    >
        <b-form>
          <ValidationObserver v-slot="{ handleSubmit }">
            <input-text
              name="poll_url"
              label="Link a encuesta"
              validate="required"
              :value.sync="pollUrl"
            />

            <b-button
              variant="primary"
              @click="handleSubmit(setTest)"
            >Guardar</b-button>
          </ValidationObserver>
        </b-form>
    </b-modal>
  </Layout>
</template>
<script>
  import BaseTable from '@components/BaseTable'
  import InputText from '@components/form/InputText'
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  export default {
    name: 'MethodologistsMyProjectsPage',
    components: {
      'base-table': BaseTable,
      'input-text': InputText,
    },
    data() {
      return {
        projectId: '',
        breadCrumb: [
          { text: 'Home', to: '/' },
          { text: 'Mis Proyectos', active: true },
        ],
        fields: [
          { key: 'name', label: 'Nombre', sortable: true },
          // { key: 'project.description', label: 'Descripción', sortable: true },
          { key: 'choose_ambits_locked', label: 'Elegir Ámbito Activo', sortable: true, class: 'text-center width-120', thclass: 'width-120' },
          { key: 'ambits_locked', label: 'Calif. Ámbitos Activo', sortable: true, class: 'text-center width-120', thclass: 'width-120' },
          { key: 'strategic_vars_locked', label: 'Variables E Activas', sortable: true, class: 'text-center width-120', thclass: 'width-120' },
          { key: 'scenario_locked', label: 'Escenarios Activo', sortable: true, class: 'text-center width-120', thclass: 'width-120' },
          { key: 'poll_locked', label: 'Encuesta Activa', sortable: true, class: 'text-center width-120', thclass: 'width-120' },
          { key: 'actions', label: 'Acciones', sortable: false, class: 'text-center width-120', thclass: 'width-120' },
        ],
        actionsBusy: false,
        testModal: false,
        pollUrl: '',
        testProject: '',
        projects: [],
      }
    },
    computed: {
      ...mapGetters({
        loadingProjects: 'methodologist/loadingProjects',
        vuex_projects: 'methodologist/projects',
      }),
      pageTitle() {
        return 'Mis Proyectos'
      }
    },
    watch: {
      vuex_projects: function (val) {
        const results = val.results
        this.projects = _.cloneDeep(results)
      }
    },
    created (){
      this.init();
    },
    methods: {
      init() {
        this.$store.dispatch('methodologist/fetchProjects')
      },
      changeAmbitsStatus(project) {
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          ambits_locked: project.ambits_locked
        }
        this.$store.dispatch('project/updateProject', payload)
      },
      changeVariableStatus(project) {
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          strategic_vars_locked: project.strategic_vars_locked
        }
        this.$store.dispatch('project/updateProject', payload)
      },
      openTestModal(project) {
        this.testProject = project
        this.pollUrl = project.poll_url || ''
        this.testModal = true
      },
      setTest() {
        const project = this.testProject
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          poll_url: this.pollUrl
        }

        this.$store.dispatch('project/updateProject', payload)

        this.testModal = false
        this.poll_url = ''
      },
      changeChooseAmbitsStatus(project) {
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          choose_ambits_locked: project.choose_ambits_locked
        }
        this.$store.dispatch('project/updateProject', payload)
      },
      changePollStatus(project) {
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          poll_locked: project.poll_locked
        }
        this.$store.dispatch('project/updateProject', payload)
      },
      changeSceneStatus(project) {
        const payload = {
          id: project.id,
          name: project.name,
          description: project.description,
          scenario_locked: project.scenario_locked
        }
        this.$store.dispatch('project/updateProject', payload)
      }
    },
  }
</script>

<style lang="scss">
  .btn-link {
    color: #6c757d !important;
    font-size: 13px;
  }
  .btn-link:hover {
    background-color: rgba(0,0,0,0.05);
    font-weight: bolder;
  }
  .text-purple {
    color: purple;
  }
</style>
